import { defineComponent as _defineComponent } from 'vue'
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { computed, provide, ref, watch } from 'vue'
import { TransitionFade } from '@morev/vue-transitions'
import Teleport from 'vue2-teleport'
import { ModalInjectionKey } from './injection-key'
import { useElementSize } from '@vueuse/core'
import { uniqueId } from 'lodash'
import { DropdownRootInjectionKey } from '@/utils/injection-keys'


const transitionDuration = 300

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalRoot',
  props: {
  maxHeight: null,
  minHeight: { default: 288 },
  maxWidth: null,
  minWidth: null,
  disabled: { type: Boolean },
  nonDismissable: { type: Boolean, default: false },
  value: { type: Boolean }
},
  emits: ["close", "input"],
  setup(__props, { emit }) {

const props = __props;

const id = uniqueId('modal')
provide(DropdownRootInjectionKey, `#${id}`)





const { modelValue } = __MACROS_useVModel(["modelValue", "value", "input"])

function close() {
  if (props.disabled) {
    return
  }
  modelValue.value = false
  emit('close')
}

 // ms
const visible = ref(modelValue.value)
watch(modelValue, (val) => {
  if (val) {
    visible.value = val
    return
  }

  setTimeout(() => {
    visible.value = val
  }, transitionDuration)
})

const overlay = ref<HTMLDivElement>()
const { height: overlayHeight } = useElementSize(overlay)

const headerHeight = ref<number>(0)
function updateHeaderHeight(height: number) {
  headerHeight.value = height
}

const footerHeight = ref<number>(0)
function updateFooterHeight(height: number) {
  footerHeight.value = height
}

const contentMaxHeight = computed(() => {
  if (props.maxHeight) {
    return `${Math.max(props.maxHeight, props.minHeight) - headerHeight.value - footerHeight.value}px`
  }
  return `${overlayHeight.value * 0.9 - headerHeight.value - footerHeight.value}px`
})

const contentMinHeight = computed(() => {
  return `${props.minHeight - headerHeight.value - footerHeight.value}px`
})

provide(ModalInjectionKey, {
  close,
  updateHeaderHeight,
  updateFooterHeight,
  contentMaxHeight,
  contentMinHeight,
})

return { __sfc: true,transitionDuration, id, props, emit, modelValue, close, visible, overlay, overlayHeight, headerHeight, updateHeaderHeight, footerHeight, updateFooterHeight, contentMaxHeight, contentMinHeight, TransitionFade, Teleport }
}

})